import { FC, memo } from 'react'
import { Footer } from 'react-components'

import {
    Container,
    FooterWrapper,
    GridWrapper,
    IconContainer,
    IconContent,
    IconLi,
    IconUl,
    Image,
    ImageWrapper,
    InnerContainerWrapper,
    InnerGridWrapper,
    LogoImage,
    LogoImagePic,
    MenuWrapper,
} from './styles'
import FooterGroupSection from './footer-group-section'
import ExternalLink from '../../../common/external-link'
import ButtonTransport from '../../../../transports/common/button-transport'
import FooterSectionTransport from '../../../../transports/common/footer-section-transport'

interface Props {
    footerSection: FooterSectionTransport
    footerLogo: ButtonTransport
    socialMediaLinks: ButtonTransport[]
    hideFooterWrapper?: boolean
}

const FooterSection: FC<Props> = ({
    footerSection: { footerGroups },
    footerLogo,
    socialMediaLinks,
    hideFooterWrapper,
}) => {
    return (
        <Footer id="footer">
            <FooterWrapper hideFooterWrapper={hideFooterWrapper}>
                <InnerContainerWrapper>
                    <MenuWrapper>
                        <FooterGroupSection footerGroups={footerGroups} />
                    </MenuWrapper>
                </InnerContainerWrapper>
            </FooterWrapper>
            <GridWrapper>
                <InnerGridWrapper>
                    <Container>
                        <ImageWrapper>
                            {!!footerLogo.image && (
                                <LogoImage href={footerLogo.url}>
                                    <LogoImagePic src={footerLogo.image.url} alt={footerLogo.text} />
                                </LogoImage>
                            )}
                        </ImageWrapper>
                        <IconContainer>
                            <IconUl>
                                {socialMediaLinks.map(socialMediaLink => (
                                    <IconLi key={socialMediaLink.text}>
                                        <ExternalLink
                                            as={IconContent}
                                            href={socialMediaLink.url}
                                            noCrawl={socialMediaLink.noCrawl}
                                        >
                                            <Image src={socialMediaLink.image?.url} alt={socialMediaLink.image?.alt} />
                                        </ExternalLink>
                                    </IconLi>
                                ))}
                            </IconUl>
                        </IconContainer>
                    </Container>
                </InnerGridWrapper>
            </GridWrapper>
        </Footer>
    )
}

export default memo(FooterSection)
